<template>
	<div class="fuel container-fluid py-4">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="hasPageChild==0">
			<el-form label-position="top" label-width="100px">
				<div class="row">
					<div class="col-md-6 form-group" v-if="false">
						<ReportParamSearch title="Search Location" v-model="stationid" :options="spbu.list" fldid="StationId" fldinfo="StationName" />
					</div> 
					<!--
					<div class="col-md-2 form-group">
						<ReportParamSelect title="Tol" name="lokasi" v-model="lokasi" :options="options.lokasi" />
					</div>-->
					<div class="col-md-3 form-group" v-if="false"> 
						<ReportParamSelect title="Area" name="area" v-model="area" :options="options.area" />
					</div>

					<div class="col-md-6">
						<el-form-item label="Station">
							<el-select v-model="stationid" clearable filterable placeholder="Select Station" size="medium" style="width:100%;">
								<el-option v-for="item3 in spbu.list" :key="item3.BOSStationId" :label="item3.StationName" :value="item3.BOSStationId">
								</el-option>
							</el-select>
						</el-form-item>
					</div>

					<div class="col-md-6" >
						<el-form-item label="Area">
							<el-radio-group v-model="area" size="small" name="area">
								<el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
							</el-radio-group>
						</el-form-item>
					</div>
					
				</div>
			</el-form>

            <div class="row mb-4">
                <div class="col-md-12">
                    <div class="">
						<el-card shadow="hover">
							<ReportResultTable reportname="StationList" :reportdata="reportdata" select_url="/plant-satgas-monitor?station=" idcol="StationId" noxls=1  :issuccess="loading.isSuccess"/>
							<Loader v-if="loading.table" :loading="loading.table" :customclass="''" class="child"/>
						</el-card>
                    </div>
                </div>
            </div>
			
		</div>	
		<Footer/>
	</div>
</template>

<script>

import Fuel from '@/components/page/Fuel.js'
import BarCard from '@/views/pages/BarCard.vue'
//import ListItem from '@/views/pages/ListItem.vue'
import ReportParamSearch from '@/views/pages/ReportParamSearch.vue'
import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
//import PetaGmap from '@/components/map/gmapSatgas.vue'
//import PieChart from '@/components/chart/Pie.js'
import Loader from '@/components/loader/Loader2.vue'
import { AxiosWithJar, Config, Penanggalan, FuelColor, Rainbow} from '@/utility.js'

export default
{
	extends:Fuel,
	components: { 
		ReportParamSearch,
		ReportParamSelect,
		ReportResultTable,
        Loader,
		//ListItem,
		//PieChart,
		//PetaGmap, 
		//BarCard,
	},
	computed:
	{
	},
	watch:
	{
		reportdata(){
			this.stationListMap = this.reportdata["data"]
				.filter(e=> e.Latitude!==null && e.Latitude!=="" && e.Longitude!==null && e.Longitude!=="")
				.map(item=>Object.assign(item,
					{id:item.StationId,name:item.StationName,lat:Number(item.Latitude.replace(',','.')),
					lng:Number(item.Longitude.replace(',','.')),Status:item.Status}))					
		},		
		stationid() {
			this.resumePilihan()
		},
		lokasi() {
			this.resumePilihan()
		},
		area() {
			this.resumePilihan()
		},
	},
	data(){
		return {
			
			tabList:[
				{name:'Station'},
			],
			options: {
				lokasi:[
					{ value: "", name: "ALL" }, 
					{ value: "TOL", name: "TOL" }, 
					{ value: "NON TOL", name: "NON TOL" }, 
				],
				area:[
					{ value: "", name: "ALL" }, 
					//{ value: "area", name: "BY AREA", field: "SalesArea" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
				],
			},
			tabIndex: this.$route.query.tab ? this.$route.query.tab : 0, 			
			showmap:false,
            //loading: true,
			stationid:"",
			reportdata:[],
			salesdata:[],			
			shiftnotupdate:[],	
			pickupnotupdate:[],			
			stationListMap:[],
			salesnontolbfsatgas:[],
			salesnontolsatgas:[],
			salestolbfsatgas:[],
			salestolsatgas:[],
			salesbbkkemasansatgas:[],
			centeringMap:{},
			zoom:5, 	
			
			lokasi: this.$route.query.lokasi ? this.$route.query.lokasi : '',	
			area: this.$route.query.area ? this.$route.query.area : '',	

			loading: {
				table: false,
				isSuccess: false,
			}
		}
	},
	mounted(){
		this.$emit('childrenRoute')
		this.loadStationList('SATGAS')
		this.resumePilihan()	
	},
    methods:{

		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')            
		},		
				
		async resumePilihan() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/fuel2/station?satgas=1'

			this.urlRequestParams += '&station='+this.stationid
			this.urlRequestParams += '&lokasi='+this.lokasi	
			this.urlRequestParams += '&area='+this.area				

            this.loading.table = true
            this.loading.isSuccess = false
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdata = response.data;
					this.loading.isSuccess = true;
				})
                .catch(/*error => {
					//console.log(error)
				}*/)
				.finally(() => {
					this.loading.table = false;
				})
				
        },
		
		searchFilterButtonClick(){
			document.querySelector('li.filter').classList.toggle('down')
			var select=document.querySelectorAll('.search.form')
			Array.from(select).map((e)=>{e.classList.toggle('minimize')})
		}
    }
}
</script>
<style>
    .peta.gmap{ position:relative; overflow: hidden; }
    .peta.gmap .search{ position: absolute; left:0px; bottom:0px; top:60px; width:300px; display:flex; flex-direction:column-reverse; overflow: hidden;}
    .peta.gmap .search .input,.peta.gmap .search .result { width:100%; z-index:1; position:relative; padding: 15px; font-size: 12px; }
    .peta.gmap .search .input{ padding: 0px 0px 15px 15px; width: 100%;    }
    .peta.gmap .search .result{ margin: 15px 15px 10px; width: 100%; border-radius: 5px; padding:0px;    }
    .peta.gmap .search .result ul{ background: linear-gradient(45deg,#c7251c 19%,transparent); list-style-type: none; border-radius: 10px; margin-bottom: 10px; overflow-y: scroll; overflow-x: hidden; max-height:220px; width: 285px;}
    .peta.gmap .search .result ul li{ padding:5px 10px;  white-space:nowrap; color:#e1e1e1; cursor: pointer;}
    .peta.gmap .search .result ul li:nth-child(2n+2){ background: #146db7; color:#fff; }
    .peta.gmap .search .input input  {
        width: 100%;
        padding: 10px;
        background: none;
        border: 1px #146db7 solid;
        border-radius: 5px;
        backdrop-filter: saturate(200%) blur(10px);
        background-color: rgba(255, 255, 255, 0.8) !important;

    }
    .peta.gmap .search .input input:focus { border:1px red solid;  outline: none;}

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>